import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import req from "../../utils/axios";
import getStatus from "../../utils/tradeStatusCode";
import { setTradeStatus } from "../../redux/actions";
import { isCreditCard } from "../../utils/validations";
import { useHistory } from "react-router-dom";

function AutoQuery() {
  const { tradeStatus, prepayId, method, payChannel } = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const isAutoQuery =
    isCreditCard() ||
    method === "Wallet" ||
    method === "PIX" ||
    (method === "Crypto" && payChannel === "PGOne") ||
    (method === "Binance" && payChannel === "PGOne") ||
    (method === "Crypto" && payChannel === "Cregis") ||
    (method === "Crypto" && payChannel === "TripleA") ||
    (method === "Binance" && payChannel === "TripleA") ||
    (method === "Crypto" && payChannel === "CHANNEL_GROUP_ROUTER") ||
    tradeStatus.query;
  const getQueryStatus = () => {
    // console.log("getQueryStatus Called!");
    req
      .post(`/api/trade/query?prepay_id=${prepayId}`)
      .then((res) => {
        // console.log("query response");
        if (res?.data?.trade_no) {
          let tradeStatus = getStatus(res.data?.trade_status);
          dispatch(setTradeStatus(tradeStatus));
          // tradeStatus !== "process" && history.replace(`/result?prepay_id=${prepayId}${returnUrlAsParam()}`);
        }
      })
      .catch(() => {});
  };
  useEffect(() => {
    // console.log("query useeffect");
    if (!["fail", "success", "other"].includes(tradeStatus.id) && isAutoQuery) {
      let increment = 0;
      const interval = setInterval(() => {
        increment++;
        // console.log("increment: ", increment);
        if ([10, 20, 30, 40, 50, 60, 80, 100, 120, 150, 180, 240, 360, 540, 780].includes(increment)) {
          getQueryStatus();
          // console.log("queryed !");
        } else if (increment > 840 || increment < 0) {
          clearInterval(interval);
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [isAutoQuery]);
  return <></>;
}

export default AutoQuery;
